// extracted by mini-css-extract-plugin
export default {"footer":"banner5_page_footer__2pzo5"};